<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {},
};
</script>

<style scoped>
</style>